import { render } from "./SuiviVentes.vue?vue&type=template&id=6ae79082"
import script from "./SuiviVentes.vue?vue&type=script&lang=js"
export * from "./SuiviVentes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__